<template>
  <div>
    <template v-if="list != null">
      <vs-card
        class="mt-5 px-5"
        v-for="(item, index) in list"
        :id="item.id"
        :key="item.id"
        v-bind:class="{ removed: item.removed }"
      >
        <!--
      <vs-row vs-w="12">
        <vs-col vs-w="12">
          <div class="mt-0 text-right">
            <vs-button
              v-if="!item.removed"
              type="border"
              size="small"
              class="mr-2"
              @click="removeItem(index)"
              ><i class="fas fa-trash-alt"></i
            ></vs-button>
            <vs-button
              v-else
              type="border"
              size="small"
              class="mr-2"
              @click="redoItem(index)"
              ><i class="fas fa-redo"></i
            ></vs-button>
          </div>
        </vs-col>
      </vs-row>
      -->
        <vs-row vs-w="12">
          <vs-col vs-justify="left" vs-align="center" vs-w="9">
            <div class="my-4">
              <label>Type</label>
              <vs-select v-model="item.question_type" @change="onTypeChanged(index)">
                <vs-select-item
                  :key="index"
                  :value="option.value"
                  :text="option.text"
                  v-for="(option, index) in options"
                />
              </vs-select>
            </div>

            <div class="my-4">
              <label>Title</label>
              <vs-input
                v-model="item.question_title"
                style="width: 90%"
                v-on:input="debounceInputTitle($event, item)"
                placeholder="Untitled"
              />
              <div
                class="pl-5 mt-5"
                v-if="['radio', 'checkbox','rank'].includes(item.question_type)"
              >
                <vs-row
                  class="my-2"
                  vs-w="12"
                  :key="j"
                  v-for="(option, j) in item.options_json"
                >
                  <vs-col vs-w="1">
                    <vs-radio class="mt-3" disabled></vs-radio>
                  </vs-col>
                  <vs-col vs-w="7">
                    <vs-input v-model="option.value" style="width: 90%" />
                  </vs-col>
                  <vs-col vs-w="4">
                    <vs-button
                      class="mr-2"
                      type="border"
                      icon="close"
                      @click="removeOpton(index, j)"
                    ></vs-button>
                  </vs-col>
                </vs-row>
                <vs-row vs-w="12" class="mt-5">
                  <vs-col vs-w="1"> </vs-col>
                  <!--
                  <vs-col vs-w="7">
                    <vs-input style="width:90%;" disabled />
                  </vs-col>
                  -->
                  <vs-col vs-w="11">
                    <vs-button
                      style="display: inline-block"
                      type="border"
                      @click="addOpton(index)"
                      >Add option</vs-button
                    >
                    <span class="px-3">or</span>
                    <vs-button
                      style="display: inline-block"
                      @click="updateItem(item)"
                      >Save</vs-button
                    >
                  </vs-col>
                </vs-row>
              </div>
            </div>

            <div class="my-4" v-if="['checkbox'].includes(item.question_type)">
              <label>Maximum Selected</label>
              <vs-input
                v-model="item.max"
                style="width:90%;"
                v-on:input="debounceInputTitle($event, item)"
              />
            </div>
            <div class="my-4">
              <label>Page Filter</label>
              <vs-input
                v-model="item.page_filter"
                style="width: 90%"
                v-on:input="debounceInputTitle($event, item)"
              />
            </div>
          </vs-col>
          <vs-col vs-justify="left" vs-align="center" vs-w="3">
            <div class="my-2">
              <label>Status</label>
              <vs-switch
                class="mt-2"
                v-model="item.publish_status"
                @change="itemChanged(item)"
              />
            </div>
            <div class="my-4">
              <label>Is Required?</label>
              <vs-switch
                class="mt-2"
                v-model="item.is_required"
                @change="itemChanged(item)"
              />
            </div>
            <!-- <div class="my-4">
              <label>Weight (0-1000)</label>
              <vs-input v-model="item.weight" style="width:90%;" />
            </div> -->
          </vs-col>
          <!--
          <vs-col vs-justify="right" vs-align="right" vs-w="1">
            <div class="mt-2">
              <label></label>
              <div class="mt-0">
                <vs-button
                  class="mr-2"
                  type="border"
                  icon="trash"
                  @click="removeItem(index)"
                ></vs-button>
              </div>
            </div>
          </vs-col>
          -->
        </vs-row>
      </vs-card>

      <!-- <div class="vx-row pt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="mr-3 mb-2" @click="submit">Submit</vs-button>
        </div>
      </div> -->
    </template>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  props: ["list"],
  computed: {
    ...mapState({
      accessToken: (state) => {
        return state.Auth.accessToken;
      },
    }),
  },
  data() {
    return {
      options: [
        { text: "Short answer", value: "text" },
        { text: "Number", value: "number" },
        { text: "National ID", value: "citizenid" },
        { text: "Paragraph", value: "textarea" },
        { text: "Date", value: "date" },
        { text: "Birthdate", value: "birthdate" },
        { text: "Multiple choice", value: "radio" },
        { text: "Checkboxes", value: "checkbox" },
        { text: "Dropdown", value: "select" },
        { text: "Country", value: "country" },
        { text: "Province (Thailand)", value: "province-thailand" },
        { text: "Image Upload", value: "uploadimage" },
        { text: "Rank", value: "rank" },
        // { text: "Location (latitude, longitude)", value: "map" },
        // { text: "Travel Distance", value: "distance" },
        { text: "Divider", value: "divider" },
      ],
      items: [],
      nextTodoId: 2,
    };
  },
  created() {
    let hasExist = false;

    this.items.map((item) => {
      if (item.field_opt != null) {
        let o = item.field_opt.split(";");
        o.map((o) => {
          item["options"].push({ text: o });
        });
      }
    });
  },
  methods: {
    onTypeChanged(index) {
      const item = this.list[index];
      if(['radio', 'checkbox','rank'].includes(item.question_type) && (!this.items[index].options || !this.items[index].options.length) ){
        this.addOpton(index)
      }
    },
    repeateAgain() {
      if (this.items.length < 10) {
        let data = {};
        data["field_q"] = "";
        data["field_opt"] = null;
        data["field_desc"] = "";
        data["question_type"] = "text";
        data["field_status"] = true;
        data["can_delete"] = true;
        this.items.push({
          ...data,
        });
      }
    },
    removeItem(index) {
      this.items[index].removed = true;
    },
    redoItem(index) {
      this.items[index].removed = false;
    },
    addOpton(index, other = false) {
      if (!other) {
        this.items[index].options_json.push({
          text: "",
        });
      } else {
        this.items[index].other = true;
        // this.items[index].options.push({
        //   text: "Other",
        // });
      }
      const newitems = [];
      // let hasOther = false
      for (const item of this.items[index].options_json) {
        // if (item.text != "Other") {
        //   newitems.push({
        //     text: item.text,
        //   });
        // } else {
        //   hasOther = true
        // }
        newitems.push({
          text: item.text,
        });
      }
      // if (hasOther) {
      //   newitems.push({
      //     text: "Other",
      //   });
      // }
      this.items[index].options_json = newitems;
    },
    updateItem(item) {
      Service.Question.updateQuestion(item).then((res) => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success",
        });
      });
    },
    removeOpton(index, j) {
      this.list[index].options_json.splice(j, 1);
    },
    debounceInputTitle: _.debounce(function (e, item) {
      let _this = this;

      let index = item.validations.findIndex(x => x.rule == "max");
      item.validations[index].value = parseInt(item.max);

      _this.$vs.loading();
      Service.Question.updateQuestion(item).then((res) => {
        _this.$vs.loading.close();
        _this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success",
        });
      });
    }, 500),
    itemChanged(item) {
      console.log("itemChanged");
      this.$vs.loading();
      Service.Question.updateQuestion(item).then((res) => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success",
        });
      });
    },
  },
};
</script>
<style lang="scss">
.removed {
  background-color: #eee;
}
</style>
